<template>
  <div class="maintenance-banner" :class="{ hidden: maintenanceDatePassed }">
    <p>
      KYC Infogreffe sera indisponible
      <b>dimanche 26 juin 2022 de 08h00 à 13h00,</b> en raison d’une opération de maintenance programmée.
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    maintenanceDatePassed() {
      return new Date() > new Date('June 26, 2022 13:00:00');
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.maintenance-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background: colors.$darkblue-color;
  padding: 8px 0;
  width: 100%;
  color: colors.$white-color;
  font-size: 12px;
  text-align: center;

  &.hidden {
    display: none;
  }

  p {
    margin: 0;
  }
}

@media (min-width: responsive.$layout-breakpoint-medium) {
  .maintenance-banner {
    font-size: 14px;
  }
}

@media (min-width: responsive.$layout-breakpoint-large) {
  .maintenance-banner {
    font-size: 16px;
  }
}
</style>
